import { addSignedUrlsToBroadcast, withCurrentParams } from 'actions/utils';
import { BROADCAST_SYNC_LAYER_SOURCES } from 'actions/Types';

export default broadcast => {
  return withCurrentParams((dispatch, { teamId, eventId }) => {
    const action = {
      type: BROADCAST_SYNC_LAYER_SOURCES,
      request: async apiClient => {
        return await addSignedUrlsToBroadcast(
          broadcast,
          apiClient,
          teamId,
          eventId
        );
      }
    };

    dispatch(action);
  });
};
